import { useNavigate } from 'react-router-dom';
import { useAuth } from '@screentone/addon-auth-wrapper';
import { FabButton, IconPlus, Typography, Wrapper } from '@screentone/core';

import { HelpIcon } from 'components';
import { CollectionSearch } from 'components/collection-search/CollectionSearch';
import { FILTER_TYPES } from 'components/collection-search/components/collections-search-bar/CollectionsSearchBar';
import { useAlert } from 'contexts/alert/useAlert';
import { CollectionDtoStatusType } from 'data/generated/graphql';
import { useConvertedProperty } from 'hooks';
import styles from './Collections.module.scss';

export const Collections = () => {
  const currentProperty = useConvertedProperty();
  const { currentProperty: routeProperty } = useAuth();
  const navigate = useNavigate();
  const { alertError } = useAlert();

  const handleCreateCollection = () => {
    if (!currentProperty || !routeProperty) {
      return;
    }

    try {
      navigate(`/${routeProperty}/collections/new`);
    } catch (e: unknown) {
      alertError('Could not create a collection. Please try again.');
    }
  };

  return (
    <Wrapper data-testid="collections-container" margin={{ top: 'lg' }}>
      <Wrapper data-testid="collections-header" className={styles.allCollectionsTitle} margin={{ bottom: 'md' }}>
        <Typography data-testid="collections-title" variant="header2" margin={{ all: 'none' }}>
          All Collections
        </Typography>
        <HelpIcon
          data-testid="collections-help-icon"
          text="A collection is a group of curated content and/or an auto-generated list of content from a query. Collections are used for sharing the same content across multiple pages."
          isLeftAnchored
        />
      </Wrapper>
      <CollectionSearch
        filters={[
          { filterType: FILTER_TYPES.SORT, label: 'Sort' },
          { filterType: FILTER_TYPES.STATUS, label: 'Status' }
        ]}
        initialCollectionsInput={{
          status: CollectionDtoStatusType.Live
        }}
      />
      <FabButton data-testid="collections-create-button" icon={IconPlus} onClick={handleCreateCollection} />
    </Wrapper>
  );
};
